var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonolitLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 64,
    viewBox: "0 0 154 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4288 23.9826V62.5909C26.4288 62.745 26.3517 62.8992 26.1976 63.0532C25.9921 63.2074 25.7609 63.2844 25.5041 63.2844H15.563C15.3062 63.2844 15.1006 63.2074 14.9465 63.0532C14.7924 62.8992 14.7153 62.745 14.7153 62.5909V23.9826H26.4288ZM2.84773 12.1921C2.28254 12.1921 2 11.9609 2 11.4986V2.3281C2 2.17395 2.07708 2.01991 2.23123 1.86575C2.43669 1.7116 2.64216 1.63452 2.84773 1.63452H38.2194C38.4761 1.63452 38.6817 1.7116 38.8359 1.86575C38.9899 2.01991 39.067 2.17395 39.067 2.3281V11.4986C39.067 11.9609 38.7845 12.1921 38.2194 12.1921H2.84773Z",
    fill: "#020217"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0927 1.41492C57.5624 1.41492 61.5439 1.74888 65.0373 2.4168C69.6097 3.23877 73.5142 4.62593 76.7509 6.57817C85.0222 11.5101 89.1579 20.064 89.1579 32.2399C89.1579 44.0048 85.0736 52.4302 76.9049 57.5163C70.9455 61.2153 63.008 63.0648 53.0927 63.0648H42.9975C42.7921 63.0648 42.5865 62.9878 42.381 62.8336C42.2269 62.6796 42.1499 62.5254 42.1499 62.3712V38.1737H53.9404V51.7367C55.0707 51.7881 56.1238 51.7881 57.0999 51.7367C58.3843 51.7367 59.5917 51.6596 60.7218 51.5054C63.6503 51.1458 66.219 50.4009 68.4282 49.2707C74.3362 46.1881 77.2903 40.5112 77.2903 32.2399C77.2903 25.2529 75.0812 20.064 70.6629 16.6733C66.6043 13.6421 61.0301 12.3064 53.9404 12.666V26.3061H42.1499V2.1085C42.1499 1.95435 42.2269 1.8003 42.381 1.64615C42.5865 1.492 42.7921 1.41492 42.9975 1.41492H53.0927Z",
    fill: "#020217"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.094 28.0866L124.071 60.2145C124.018 60.3199 123.913 60.4253 123.755 60.5306C123.597 60.636 123.469 60.6887 123.364 60.6887H113.7C113.595 60.6887 113.437 60.636 113.226 60.5306C113.068 60.4253 112.963 60.3199 112.91 60.2145L95.864 27.2211V62.4874C95.864 62.6454 95.7887 62.8035 95.6307 62.9615C95.42 63.1195 95.2092 63.1948 94.9985 63.1948H84.6279C84.3645 63.1948 84.1537 63.1195 83.9957 62.9615C83.8903 62.8035 83.8376 62.6454 83.8376 62.4874V1.06119C83.8376 0.90315 83.8903 0.745103 83.9957 0.58706C84.1537 0.429017 84.3645 0.35376 84.6279 0.35376H95.1566C95.2619 0.35376 95.42 0.406446 95.6307 0.511808C95.7887 0.61717 95.8941 0.722531 95.9468 0.827893L118.487 46.8561L139.928 0.827893C140.139 0.511807 140.425 0.35376 140.793 0.35376H151.164C151.428 0.35376 151.638 0.429017 151.796 0.58706C151.954 0.745103 152.03 0.90315 152.03 1.06119L152.06 42.1675V62.1487H139.958L140.094 28.0791V28.0866Z",
    fill: "#005CA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8525 61.5089L88.5411 57.6782L83.8525 52.1467V61.2982V61.5089Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4968 61.5089L100.485 52.523L89.4968 39.5259V61.0198V61.5089Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4028 53.2681L96.3906 49.2418L85.4028 43.4167V53.0499V53.2681Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6605 62.7808L85.5984 58.7544L95.6605 52.9219V62.5625V62.7808Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0935 40.5795L95.0813 28.2371L84.0935 10.3857V39.9172V40.5795Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5088 49.5578L93.7562 41.4148L86.5088 29.6368V49.1213V49.5578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonolitLogo);
export default __webpack_public_path__ + "static/media/monolit-logo.fb5941c10d2dceabaac479b0230ed9c4.svg";
export { ForwardRef as ReactComponent };